import { AfterViewInit, Component, ContentChild, ContentChildren, EventEmitter, Input, OnChanges, Output, QueryList, SimpleChanges, ViewChild, Optional, Host, ChangeDetectorRef, ApplicationRef, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatColumnDef, MatTable } from '@angular/material/table';
import * as moment from 'moment';
import { debounceTime } from 'rxjs/operators';
import { ComponentBase, RentalObjectInfo, ReportInfo, T4DataService, T4DataSource } from 't4core';
import { HttpProgress, HttpProgressStatus } from '../../../../projects/t4core/src/lib/services/api.service';
import { ReportRunInfo } from 't4core';
import { createScheduledReportDialog } from '../../dialogs/createScheduledReportDialog/createScheduledReportDialog';
import { T4DatatableWidget } from '../datatable/datatable';

@Component({
    selector: 't4-report',
  templateUrl: './report.html',
  styleUrls: ['./report.css']
})

export class T4Report extends ComponentBase implements OnInit {
  @Input() public reportId: string;
  @Input() public isExcelOnly: boolean = false;
  public scheduledReport: string = null;

  @ViewChild('tblRuns') private tblRuns: T4DatatableWidget;

  public isLoading: boolean = false;
  public report: ReportInfo;
  public runs: ReportRunInfo[] = [];

  constructor(private dialog: MatDialog, @Optional() @Host() sort: MatSort, private _app: ApplicationRef, private dataSvc: T4DataService) {
    super();
  }

  async secondTick() {
    if (moment().second() % 10 == 0) {
      if (this.runs.some(x => !x.RunTime))
        this.runs = await this.dataSvc.GetReportRuns(this.reportId);
    }
  }

    ngOnInit(): void {
      this.update();
    }

  public async update() {
    this.isLoading = true;

    this.report = await this.dataSvc.GetReport1(this.reportId);
    this.runs = await this.dataSvc.GetReportRuns(this.reportId);

    this.isLoading = false;
    this.checkScheduledReport();
  }
 
  public async toggleSchedule() {
    if (this.scheduledReport) {
      var x = await this.UI.confirm("Turbo.Core.CreateScheduledReportDialog.DeleteTitle", "Delete existing report?", "Turbo.Core.CreateScheduledReportDialog.DeleteMsg", 'A scheduled report for this table already exist. Do you want to delete it?');
      if (x) {
        var deleted = await this.dataSvc.DropReportSchedule(this.scheduledReport);
        if (deleted) {
          this.UI.snackBar(this.translate("Turbo.Service.CreateScheduledReport.ReportDeletedSuccess.Message", "The scheduled report has been deleted."));
          this.checkScheduledReport();
        }
        else {
          this.UI.alert("Turbo.Service.CreateScheduledReport.ReportDeletedFailed.Headline", "Failed!", "Turbo.Service.CreateScheduledReport.ReportDeletedFailed.Headline.Message", "The scheduled report could not be deleted.");
        }
      }
    }
    else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        reportId: this.reportId
      };

      const dialogRef = this.dialog.open(createScheduledReportDialog, dialogConfig);

      dialogRef.afterClosed().subscribe(
        data => this.checkScheduledReport());
    }
  }

  async checkScheduledReport() {
    if (this.reportId) {
      this.scheduledReport = await this.dataSvc.GetReportSchedule(this.reportId);
    }
  }

  public downloadReport(uri: string) {
    window.open(uri, '_blank');
  }

  // Generation
  public fromDate: moment.Moment = moment().startOf('month');
  public toDate: moment.Moment = moment().startOf('month').add(1, 'month');
  public format: string = "1";

  public async runReport() {
    var run = await this.dataSvc.RunReport(this.reportId, this.fromDate, this.toDate, this.format);
    this.update();

    run == this.runs.find(x => x.Id == run.Id);
    this.tblRuns.toggleRowSelection(run);
    this.tblRuns.update();
  }
}
